import { supabase } from "@/supabaseClient";

export async function uploadStudioLogo({ studioId, file }) {
  if (!studioId) return { ok: false, error: "studioId missing" };
  if (!file) return { ok: false, error: "file missing" };

  const ext = (file.name.split(".").pop() || "png").toLowerCase();
  const safeExt = ["png", "jpg", "jpeg", "webp", "svg"].includes(ext) ? ext : "png";

  const fileName = `logo-${Date.now()}.${safeExt}`;
  const path = `${studioId}/${fileName}`; // ✅ studioId prefix

  const { error: uploadErr } = await supabase.storage
    .from("studio-logos")
    .upload(path, file, {
      cacheControl: "3600",
      upsert: true,
      contentType: file.type || undefined,
    });

  if (uploadErr) return { ok: false, error: uploadErr };

  // Bucket is PUBLIC, so this yields a stable public URL
  const { data } = supabase.storage.from("studio-logos").getPublicUrl(path);
  const url = data?.publicUrl || "";

  return { ok: true, url, path };
}

export function getLogoPathFromPublicUrl(publicUrl) {
  try {
    // .../storage/v1/object/public/studio-logos/<path>
    const marker = "/storage/v1/object/public/studio-logos/";
    const idx = publicUrl.indexOf(marker);
    if (idx === -1) return null;
    return publicUrl.slice(idx + marker.length);
  } catch {
    return null;
  }
}

export async function deleteStudioLogoByUrl(publicUrl) {
  const path = getLogoPathFromPublicUrl(publicUrl);
  if (!path) return { ok: false, error: "Could not parse storage path from URL" };

  const { error } = await supabase.storage.from("studio-logos").remove([path]);
  if (error) return { ok: false, error };
  return { ok: true };
}
